module.exports = __webpack_public_path__ + "img/94.19408c8e.jpg";